<template>
	<ul>
	    <li class="cursor-pointer border-bottom pt-1 pb-2 px-2" v-for="(contact, index) in getFilterDependencies" :key="index">
	        <vs-row class="mt-5">
	            <vs-col  vs-type="flex"  vs-align="flex-end" vs-w="10" vs-sm="12" class="text-left">
	                <div class="w-full" @click="senAnswer(contact)">
	                    <span class="block font-bold">
	                        {{contact.name}}	                        
	                    </span>
	                    <p class="truncate ">
	                        {{contact.label}}	                        
	                    </p>                                                        
	                </div>
	            </vs-col>
	            <vs-col  vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2" vs-sm="12" class="text-left">
	                <feather-icon class="ml-3"  icon="Trash2Icon" svgClasses="h-7 w-7" @click="$emit('deleteDependenceCompound',contact.name)"/>
	            </vs-col>
	        </vs-row>                                           
	    </li>
	</ul>
</template>

<script type="text/javascript">
	export default {
		props: {
			getFilterDependencies: {
				type: [Array, Object],
				required: false,
				default: []
			}
		},
		methods: {
			senAnswer(question) {				
				let answer = 'answer';
				if(question.relatedness === 'multiple') answer = 'answers';
				let _answer = question[answer];
				if(_answer === null || _answer === undefined) _answer = question.options;			

				const data = {
					name: question.name,
					[answer]: _answer,
					inputType: question.inputType,
					label: question.label
				}				
				this.$emit('answerCompound', data);
			}
		}	
	}

	// { "name": "P_0", "relatedness": "simple", "answer": "TTTTTTTTTTTTTTTTT", "question": 0, "label": "JJJJJJJJJJJJJJJJJJJJ" }
</script>

